import type { CreatePriceRuleRequest, OperatingHourRequest } from "../types";

export interface PriceRuleFieldErrors {
  name?: string;
  interval?: string;
  hourlyRate?: string;
  priority?: string;
  days?: string;
}

export function validateOperatingHours(days: OperatingHourRequest[]): string[] {
  const errors: string[] = [];
  const uniqueDays = new Set(days.map(day => day.dayOfWeek));
  if (days.length !== 7 || uniqueDays.size !== 7) {
    errors.push("A grade deve conter os sete dias da semana sem duplicidade.");
  }

  for (const day of days) {
    if (day.isClosed) {
      if (day.openTime !== null || day.closeTime !== null) {
        errors.push("Dias fechados não devem possuir horários.");
      }
      continue;
    }
    if (!day.openTime || !day.closeTime || day.openTime >= day.closeTime) {
      errors.push("O horário de abertura deve ser anterior ao de fechamento.");
    }
  }

  return [...new Set(errors)];
}

export function validatePriceRule(payload: CreatePriceRuleRequest): PriceRuleFieldErrors {
  const errors: PriceRuleFieldErrors = {};
  if (payload.name.trim() === "") errors.name = "Informe o nome da regra";
  else if (payload.name.trim().length > 120) errors.name = "O nome deve ter no máximo 120 caracteres";
  if (!payload.startTime || !payload.endTime || payload.startTime >= payload.endTime) {
    errors.interval = "O horário inicial deve ser anterior ao horário final";
  }
  if (!Number.isFinite(payload.hourlyRate) || payload.hourlyRate < 0) {
    errors.hourlyRate = "O valor por hora não pode ser negativo";
  }
  if (!Number.isInteger(payload.priority) || payload.priority < 0) {
    errors.priority = "A prioridade não pode ser negativa";
  }
  if (payload.days.length === 0) errors.days = "Selecione ao menos um dia";
  return errors;
}
